export default __webpack_public_path__ + "static/Edita_Prima_photo_bg_services_page-2a6f81bb70f5dcfc7e5b0cf3755e0b1d.jpg";